import UpdateUserRequestModelBase from '../_generated/modelBases/update-user-request-model-base';

export default class UpdateUserRequestModel extends UpdateUserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
